<div class="demographics-container" *ngIf="demographicData">
  <div class="row">
    <div class="col-sm-6 justify-padding-right">
      <div class="chart-container gender-chart">
        <achoo-pie-chart
          [chartData]="genderChartData"
          [chartTitle]="'INFLUENCER.CHART.GENDER' | translate"
          [height]="pieHeight"
          [pieCenter]="pieCenter"
          [pieSize]="pieSize"
          [pieInnerSize]="pieInnerSize"
          [titleStyling]="pieTitleStyling"
          [titleTooltip]="'info_box.influencer.gender' | translate"
          [listLegendPlaceholder]="['Male', 'Female']"
          [legend]="pieLegend">
        </achoo-pie-chart>
      </div>
    </div>
    <div class="col-sm-6 justify-padding-left">
      <div class="chart-container country-chart">
        <achoo-pie-chart
          [chartData]="countriesChartData"
          [chartTitle]="'INFLUENCER.CHART.COUNTRIES' | translate"
          [height]="pieHeight"
          [pieCenter]="pieCenter"
          [pieSize]="pieSize"
          [pieInnerSize]="pieInnerSize"
          [titleStyling]="pieTitleStyling"
          [legend]="pieLegend"
          [listLegendPlaceholder]="['Demark', 'UAE', 'United State', 'United Kingdom']"
          [titleTooltip]="'info_box.influencer.countries' | translate">
        </achoo-pie-chart>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <div class="chart-container">
        <gender-per-age-chart *ngIf="isGenderPerAgeAvailabel"
                              [chartData]="genderPerAgeChart"
                              [maxPercent]="genderPerAgeChartMaxPercent">
        </gender-per-age-chart>
        <div class="gender-per-age-placeholder" *ngIf="!isGenderPerAgeAvailabel">
          <gender-per-age-chart [isPlaceholder]="true"
                                [chartData]="[{'range': '13-17', 'm': 60, 'f': 60}, {'range': '18-24', 'm': 60, 'f': 60}, {'range': '25-34', 'm': 60, 'f': 60}, {'range': '35-44', 'm': 60, 'f': 60}]"
                                [maxPercent]="80">
          </gender-per-age-chart>
          <div class="message-popup">
            <div class="title">{{'demographic_fallback.missing_gender_per_age_title' | translate}}</div>
            <div>{{'demographic_fallback.missing_gender_per_age_msg' | translate}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 justify-padding-right">
      <div class="chart-container audience-type-chart" *ngIf="hasAudienceTypeData">
        <achoo-pie-chart
          [chartData]="audienceTypeChartData"
          [chartTitle]="'hype_auditor_demographic.audience_type.title' | translate"
          [height]="pieHeight"
          [pieCenter]="pieCenter"
          [pieSize]="pieSize"
          [pieInnerSize]="pieInnerSize"
          [titleStyling]="pieTitleStyling"
          [forPayingUser]="true"
          [listLegendPlaceholder]="['Real People', 'Influencers', 'Mass followers', 'Suspicious Accounts']"
          [legend]="pieLegend"
          [titleTooltip]="'info_box.influencer.audience_type' | translate">
        </achoo-pie-chart>
      </div>
      <div class="chart-container bar-chart-city" *ngIf="!hasAudienceTypeData">
        <div class="d-flex flex-row align-items-center">
          <span class="bar-chart-title">{{'hype_auditor_demographic.cities.title' | translate}}</span>
          <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.audience_city' | translate" [placement]="'bottom-left'"></achoo-icon-tooltip>
        </div>
        <achoo-bar-chart [series]="citiesBarChartData"
                         [showIndex]="false"
                         [showValue]="true"
                         [isLeftSide]="true"
                         [hideRelativeCalculation]="true"
                         [chartTitleClasses]="'demographic-title'"
                         [forPayingUser]="true"
                         [placeholderKeywords]="['United State', 'Denmark', 'England', 'United Arab Emirates', 'Germany']"
                         [isNormalLine]="false"
                         [maxLine]="5"
                         [showPlaceholder]="citiesBarChartData.length === 0">
        </achoo-bar-chart>
      </div>
    </div>
    <div class="col-sm-6 justify-padding-left" *ngIf="languagesBarChartData">
      <div class="chart-container bar-chart-lang">
        <div class="d-flex flex-row align-items-center">
          <span class="bar-chart-title">{{'hype_auditor_demographic.languages.title' | translate}}</span>
          <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.audience_lang' | translate"></achoo-icon-tooltip>
        </div>
        <achoo-bar-chart [series]="languagesBarChartData"
                         [showIndex]="false"
                         [showValue]="true"
                         [isLeftSide]="true"
                         [hideRelativeCalculation]="true"
                         [chartTitleClasses]="'demographic-title'"
                         [forPayingUser]="true"
                         [chartBgColor]="languageChartColor"
                         [placeholderKeywords]="['English', 'Spain', 'Danish', 'French', 'Abaric']"
                         [isNormalLine]="false">
        </achoo-bar-chart>
      </div>
    </div>
    <div class="message-popup freemium" *ngIf="isFreeUser && !isAdmin">
      <div class="title">{{fallbackTitle}}</div>
      <div class="sub-title">{{fallbackMessage}}</div>
    </div>
  </div>
  <div class="chart-container bar-chart audience-int-chart" *ngIf="demographicData.audienceInterest">
    <div class="row">
      <div class="col-sm-12 d-flex flex-row align-items-center">
        <span class="bar-chart-title">{{'hype_auditor_demographic.audience_interests.title' | translate}}</span>
        <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.audience_interests' | translate"></achoo-icon-tooltip>
      </div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-sm-6 first-audience-interest">
            <achoo-bar-chart [series]="firstHalfAudienceInterestChartData"
                             [isLeftSide]="false"
                             [showIndex]="true"
                             [isPercentValue]="true"
                             [forPayingUser]="true"
                             [showValue]="false"
                             [showPlaceholder]="!hasAudienceInterestData">
            </achoo-bar-chart>
          </div>
          <div class="col-sm-6 second-audience-interest">
            <achoo-bar-chart [series]="secondHalfAudienceInterestChartData"
                             [isLeftSide]="false"
                             [showIndex]="true"
                             [isPercentValue]="true"
                             [startIndex]="startingIndexOfSecondHalf"
                             [forPayingUser]="true"
                             [showValue]="false"
                             [showPlaceholder]="!hasAudienceInterestData">
            </achoo-bar-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row section-content">
    <div class="col-sm-6 justify-padding-right" *ngIf="hasAudienceTypeData && !isExportingPdf">
      <div class="chart-container bar-chart-city">
        <div class="d-flex flex-row align-items-center">
          <span class="bar-chart-title">{{'hype_auditor_demographic.cities.title' | translate}}</span>
          <achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.audience_city' | translate"></achoo-icon-tooltip>
        </div>
        <achoo-bar-chart [series]="citiesBarChartData"
                         [showIndex]="false"
                         [showValue]="true"
                         [isLeftSide]="true"
                         [hideRelativeCalculation]="true"
                         [chartTitleClasses]="'demographic-title'"
                         [forPayingUser]="true"
                         [placeholderKeywords]="['United State', 'Denmark', 'England', 'United Arab Emirates', 'Germany']"
                         [isNormalLine]="false"
                         [maxLine]="5"
                         [showPlaceholder]="citiesBarChartData.length === 0">
        </achoo-bar-chart>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/demographic-hype-auditor/demographic-hype-auditor.component.html